import React, { useReducer, createContext, useContext } from "react";

const MAX_PAGE_SIZE = 100;
const INIT_PAGE_SIZE = 10;
const INIT_PAGE = 1;

const initialState = {
  mergedLocations: {},
  sizePerPage: INIT_PAGE_SIZE,
  page: INIT_PAGE,
  search: "",
  sortBy: "createdAt",
  direction: "asc",
};

const ACTIONS = {
  SORT: "SORT",
  SEARCH: "SEARCH",
  REFRESH: "REFRESH",
  PAGE_CHANGE: "PAGE_CHANGE",
  PAGE_SIZE_CHANGE: "PAGE_SIZE_CHANGE",
  GET_MERGED_LOCATIONS_SUCCESS: "GET_MERGED_LOCATIONS_SUCCESS",
};

const reducer = (state, data) => {
  switch (data.action) {
    case ACTIONS.GET_MERGED_LOCATIONS_SUCCESS: {
      const { payload } = data;
      const { mergedLocations } = payload;

      return {
        ...state,
        mergedLocations,
      };
    }

    case ACTIONS.SORT: {
      const { payload } = data;
      const { sortBy, direction } = payload;

      return {
        ...state,
        sortBy,
        direction,
        page: INIT_PAGE,
      };
    }

    case ACTIONS.SEARCH: {
      const { payload } = data;
      const { search } = payload;

      return {
        ...state,
        search,
        page: INIT_PAGE,
      };
    }

    case ACTIONS.REFRESH:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case ACTIONS.PAGE_CHANGE: {
      const { payload } = data;
      const { page } = payload;
      return {
        ...state,
        page,
      };
    }

    case ACTIONS.PAGE_SIZE_CHANGE: {
      const { payload } = data;
      const { sizePerPage } = payload;
      return {
        ...state,
        sizePerPage,
        page: INIT_PAGE,
      };
    }

    default:
      throw new Error();
  }
};

const AudtiMergedLocationsContext = createContext(initialState);

const AudtiMergedLocationsProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <AudtiMergedLocationsContext.Provider value={stateAndDispatch}>
      {children}
    </AudtiMergedLocationsContext.Provider>
  );
};

export const useAuditMergedLocations = () =>
  useContext(AudtiMergedLocationsContext);

export {
  AudtiMergedLocationsContext,
  AudtiMergedLocationsProvider,
  ACTIONS,
  MAX_PAGE_SIZE,
};
